import { IAcao } from "./IAcao";
import IUnidadeUnitizadoresItensGeralAlerta from "./IUnidadeUnitizadoresItensGeralAlerta";
import { IUnitizador } from "./IUnitizador";

export interface IItem {
    id:           number;
    idLista:      string;
    objeto:       string;
    codSroOrig:   string;
    codSroDest:   string;
    dtHrCriacao:  string;
    dtHrInsercao: string;
    tipoEvento:   string;
    matricula:    string;
    status:       string;
    prazo:        number;
    motivo:       number;
    motivoTipo:    string;
    matriculaTratamento:    string;
    acao?:         IAcao | null;
    unitizador: IUnitizador;
}

export const createItemAlertaAlterar = (codSroUnidade: string,matriculaTratamento:string, status: string,motivo:number,motivoTipo:string,item: IUnidadeUnitizadoresItensGeralAlerta) => {
    return {id: item.idItem, idLista: item.id, objeto: item.objeto, codSroOrig: item.codSroOrigem, codSroDest: codSroUnidade,matricula: matriculaTratamento, motivo: motivo, motivoTipo: motivoTipo, status: status}
}